import type { RootState } from "types/redux";

export const getCustomContentDeleteError = (contentId: string | undefined) => (state: RootState) =>
  contentId !== undefined && (state.domains.customContentAndSources.deleteContent[contentId]?.error ?? false);

export const getCustomContentIsDeleting = (contentId: string | undefined) => (state: RootState) =>
  contentId !== undefined && (state.domains.customContentAndSources.deleteContent[contentId]?.isPending ?? false);

export const createTopicCustomContentSelector = (id: string) => (state: RootState) =>
  state.domains.customContentAndSources.topicContent[id]?.data;

export const getTopicCustomContentHasNextPage = (topicId: string) => (state: RootState) =>
  state.domains.customContentAndSources.topicContent[topicId]?.hasNextPage ?? false;

export const getTopicCustomContentIsPending = (topicId: string) => (state: RootState) =>
  state.domains.customContentAndSources.topicContent[topicId]?.isPending ?? false;

export const getInProgressCustomDocument = (state: RootState) =>
  state.domains.customContentAndSources.uploadContent.document;

export const getCustomContentUploadError = (state: RootState) =>
  state.domains.customContentAndSources.uploadContent.error;

export const getCustomContentIsUploading = (state: RootState) =>
  state.domains.customContentAndSources.uploadContent.isPending;

const getScrapedCustomArticleState = (state: RootState) =>
  state.domains.customContentAndSources.uploadContent.knowledge;

export const getCustomContentFormValid = (state: RootState) => {
  const { document, knowledge } = state.domains.customContentAndSources.uploadContent;
  return (
    ((!!document?.file || !!document?.id) && !!document?.filename && !document?.isFileTooBig) ||
    (!!knowledge?.data?.link && !!knowledge?.data?.title)
  );
};

export const getScrapedCustomArticleIsPending = (state: RootState) =>
  getScrapedCustomArticleState(state)?.isPending ?? false;

export const getScrapedCustomArticleHasErrored = (state: RootState) =>
  getScrapedCustomArticleState(state)?.error ?? false;

export const getScrapedCustomArticle = (state: RootState) => getScrapedCustomArticleState(state)?.data;

export const getInProgressCustomContentId = (state: RootState) =>
  getScrapedCustomArticle(state)?.id ?? getInProgressCustomDocument(state)?.id;

export const getIsNewCustomContent = (state: RootState) => !getInProgressCustomContentId(state);
